import { type UndefinedInitialDataOptions, useQuery } from "@tanstack/react-query";

import { getChecklistSummaryStats, type ChecklistSummaryStats } from "../../../../../api/getChecklistSummaryStats";
import { useSalesContext } from "../../../../../sales-context/SalesContext";

interface ChecklistSummaryStatsParams {
    start: string;
    end: string;
}

interface ChecklistSummaryQueryProps extends Partial<
    UndefinedInitialDataOptions<
        ChecklistSummaryStats | undefined,
        Error,
        ChecklistSummaryStats | undefined,
        [string, ChecklistSummaryStatsParams, string]
    >
> {
    params: ChecklistSummaryStatsParams;
}

export function useChecklistSummaryQuery({ params, ...rest }: ChecklistSummaryQueryProps) {
    const { logger, employeeId, apiClients } = useSalesContext();

    return useQuery({
        queryKey: ["checklist-summary", params, employeeId],
        queryFn: async () => getChecklistSummaryStats(apiClients.gamification, logger, params.start, params.end),
        ...rest,
    });
}
